/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandAzure = createReactComponent("outline", "brand-azure", "IconBrandAzure", [["path", { "d": "M6 7.5l-4 9.5h4l6 -15z", "key": "svg-0" }], ["path", { "d": "M22 20l-7 -15l-3 7l4 5l-8 3z", "key": "svg-1" }]]);

export { IconBrandAzure as default };
//# sourceMappingURL=IconBrandAzure.mjs.map
